/** Shared class strings for v2. Tokens only — see DESIGN_PLAN.md §0. */

/**
 * The accessibility floor: focus is always visible, on every interactive
 * element. Never `outline-none` without this.
 */
export const FOCUS_RING =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#3b82f6]/60 focus-visible:ring-offset-2 focus-visible:ring-offset-[#0a0a0a]';

/** Same ring, offset against a raised surface rather than the page. */
export const FOCUS_RING_SURFACE =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#3b82f6]/60 focus-visible:ring-offset-2 focus-visible:ring-offset-[#0f0f0f]';

/** The dominant card treatment across TicketsPage / TransfersPage. */
export const CARD_SURFACE = 'rounded-2xl border border-white/[0.06] bg-white/[0.02]';

/** Row-level surface inside a card or list. */
export const ROW_SURFACE = 'rounded-xl border border-white/[0.06] bg-white/[0.02]';

export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}
